module.exports = __webpack_public_path__ + "img/icb-co-Adv-m@2x.4ad9da17.png";